(ns dre.modals.admin.feed.views
  (:require
   [dre.app.router :as router]
   [dre.components.radio-group :refer [radio-group]]
   [dre.i18n.views :refer [tr]]
   [dre.modals.admin.feed.events :as admin-feed]
   [dre.modals.modal-window :refer [modal-window]]
   [dre.shared.interface.search.blunt :as blunt]
   [dre.shared.interface.search.pills :as pills]
   [re-frame.core :as rf]))

(defn- add-new-feed-content
  []
  (let [component-name :add-new-feed]
    [:div
     {:class [component-name :admin-modal-window-content]}
     [:div.input-group
      [:span.label
       [tr "Feed ID in lowercase without spaces"]]
      [:input.input
       {:type :text
        :on-change #(rf/dispatch [::admin-feed/on-change [:add :feed-id] (.. % -target -value)])
        :value @(rf/subscribe [::admin-feed/value-of [:add :feed-id]])}]]
     [:div.input-group
      [:span.label
       [tr "Link"]]
      [:input.input
       {:type :text
        :on-change #(rf/dispatch [::admin-feed/on-change [:add :link] (.. % -target -value)])
        :value @(rf/subscribe [::admin-feed/value-of [:add :link]])}]]
     [:div.input-group
      [:span.label
       [tr "Title"]]
      [:input.input
       {:type :text
        :on-change #(rf/dispatch [::admin-feed/on-change [:add :title] (.. % -target -value)])
        :value @(rf/subscribe [::admin-feed/value-of [:add :title]])}]]
     [:div.input-group
      [:span.label
       [tr "Category"]]
      [radio-group
       {:on-change #(rf/dispatch [::admin-feed/on-change [:add :category] (:value %)])
        :checked @(rf/subscribe [::admin-feed/value-of [:add :category]])
        :options [{:id :social}
                  {:id :official}
                  {:id :news}
                  {:id :other}]}]]]))

(defn add-new-feed
  []
  [modal-window
   {:title "Add New Feed"
    :content add-new-feed-content
    :loading? @(rf/subscribe [::admin-feed/add-in-progress?])
    :submit? true
    :submit-text [tr "Create"]
    :on-submit #(rf/dispatch [::admin-feed/add-new-feed])}])

(defn- edit-feed-content
  []
  (let [component-name :edit-feed]
    [:div
     {:class [component-name :admin-modal-window-content]}
     [:div.input-group
      [:span.label
       [tr "Link"]]
      [:input.input
       {:type :text
        :disabled true
        :on-change (constantly nil)
        :value @(rf/subscribe [::admin-feed/value-of [:edit :link]])}]]
     [:div.input-group
      [:span.label
       [tr "Title"]]
      [:input.input
       {:type :text
        :on-change #(rf/dispatch-sync [::admin-feed/on-change [:edit :title] (.. % -target -value)])
        :value @(rf/subscribe [::admin-feed/value-of [:edit :title]])}]]
     [:div.input-group
      [:span.label
       [tr "Category"]]
      [radio-group
       {:on-change #(rf/dispatch [::admin-feed/on-change [:edit :category] (:value %)])
        :checked @(rf/subscribe [::admin-feed/value-of [:edit :category]])
        :options [{:id "social"}
                  {:id "official"}
                  {:id "news"}
                  {:id "other"}]}]]]))

(defn edit-feed
  []
  [modal-window
   {:title "Edit Feed"
    :content edit-feed-content
    :submit? true
    :submit-text [tr "Save"]
    :on-submit #(rf/dispatch [::admin-feed/submit-edit-form])}])

(defn- delete-feed-content
  []
  (let [component-name :delete-feed
        title @(rf/subscribe [::admin-feed/value-of [:delete :title]])
        feed-id @(rf/subscribe [::admin-feed/value-of [:delete :feed-id]])
        link @(rf/subscribe [::admin-feed/value-of [:delete :link]])
        count @(rf/subscribe [::admin-feed/value-of [:delete :_count]])
        query [(pills/source-pill (str "feeds:" feed-id))]
        query-str (blunt/print query)
        search-link (router/->route-with-query-params
                     (router/->route :search)
                     {:query query-str})]
    [:div
     {:class [component-name :admin-modal-window-content]}
     [:div
      "You are about to delete the feed "
      [:span [:b (str feed-id " ")]]
      [:a
       {:href link
        :target :_blank}
       title]
      "."]
     [:div
      [:b
       "This will permanently remove all "
       [:a
        {:href search-link}
        count]
       " articles."]]
     [:div
      "Do you want to proceed?"]]))

(defn delete-feed
  []
  [modal-window
   {:title "Confirm Delete"
    :content delete-feed-content
    :loading? @(rf/subscribe [::admin-feed/delete-in-progress?])
    :delete? true
    :on-delete #(rf/dispatch [::admin-feed/delete-feed])}])
